import { useState } from "react";

interface UseNoCoverageResult {
  email: string;
  setEmail: (v: string) => void;
  submitted: boolean;
  submitting: boolean;
  handleSubmit: () => Promise<void>;
}

/** The request form's state; `submitRequest` sends the email wherever this page's request goes. */
export function useNoCoverage(
  submitRequest: (email: string) => Promise<void>
): UseNoCoverageResult {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit() {
    if (!email) return;
    setSubmitting(true);
    try {
      await submitRequest(email);
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  }

  return { email, setEmail, submitted, submitting, handleSubmit };
}
